import { render, staticRenderFns } from "./PostListPage.vue?vue&type=template&id=57436583&"
import script from "./PostListPage.vue?vue&type=script&lang=js&"
export * from "./PostListPage.vue?vue&type=script&lang=js&"
import style0 from "./PostListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports